import React, { Component } from "react";

//Import Breadcrumb
import RCDisplayPage from "../../components/Common/RCDisplayPage";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
} from "../../store/functions";

class pageList_PlyAdjustment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      success_dlg: false,
      dynamic_title: "",
      dynamic_description: "",
      loading: false,
      error: null,
      isAdd: false,
      isEdit: false,
      isDelete: false,
      isView: false,
      isPrint: false,
    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Ply Adjustment Master";
    this.modalTitle = "Ply Adjustment Master";
    this.rtPage_Add = "AddPlyAdjustment";
    this.rtPage_Edit = "EditPlyAdjustment";
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/PlyAdjustment";

    //Event Binding
    this.btnAdd_onClick = this.btnAdd_onClick.bind(this);
    this.btnEdit_onClick = this.btnEdit_onClick.bind(this);
    this.btnDelete_onClick = this.btnDelete_onClick.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
  }

  componentDidMount() {
    this.loadGridData();
  }

  loadGridData = () => {
    this.setState({ loading: true, error: null });
    try {
      const obj = JSON.parse( sessionStorage.getItem("authUser"));
      const LoginDetails = JSON.parse(sessionStorage.getItem("loginDetails")) || [];
      console.log("LoginDetails", LoginDetails);
      const newObj = LoginDetails.find(item => item.SubMenu == "Ply Adjustment Master");
      console.log("newObj", newObj);
      // Set user permissions based on newObj
      this.setState({
        isAdd: newObj?.IsAdd == 1,
        isEdit: newObj?.IsEdit == 1,
        isDelete: newObj?.IsDelete == 1,
        isView: newObj?.IsView == 1,
        isPrint: newObj?.IsPrint == 1
      });
        Fn_FillListData(this.obj, "gridData", this.API_URL + "/Id/0");
    } catch (error) {
      this.setState({ error: "Failed to load data" });
    } finally {
      this.setState({ loading: false });
    }
  }

  handleRefresh = () => {
    this.loadGridData();
  }

  btnAdd_onClick(event, values) {
    this.props.history.push(`${this.rtPage_Add}`);
  }

  btnEdit_onClick(formData) {
    this.props.history.push(`${this.rtPage_Edit}/${formData.Id}`, {});
  }

  btnDelete_onClick(formData) {
    Fn_DeleteData(this.obj, formData.Id, this.API_URL, this.API_URL + "/Id/0");
  }

  // handleDeleteConfirm = () => {
  //   const { selectedFormData } = this.state;
  //   Fn_DeleteData(this.obj, selectedFormData.Id, this.API_URL, this.API_URL + "/Id/0");
  //   this.setState({
  //     confirm_alert: false,
  //     success_dlg: true,
  //     dynamic_title: "Success",
  //     dynamic_description: "Record deleted successfully"
  //   });
  // }

  renderGridHeader() {
    return (
      <>
        
        <th>Ply Name</th>
        <th>Type</th>
        <th>Inside</th>
        <th>Outside</th>
        {/* <th>Actions</th> */}
      </>
    );
  }

  renderGridBody(formData, index) {
    return (
      <>
        
        <td>{formData.PlyName || '-'}</td>
        <td>{formData.TypeName || '-'}</td>
        <td>{formData.InsidePaperNames || '-'}</td>
        <td>{formData.OutsidePaperNames || '-'}</td>
         {/* <td>
          <div className="d-flex gap-2">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => this.btnEdit_onClick(formData)}
            >
              <i className="fas fa-edit"></i>
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={() => this.btnDelete_onClick(formData)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </td>   */}
      </>
    );
  }

  renderModalBody(selectedFormData) {
    return (
      <div className="p-3">
        <h5>Ply Adjustment Details</h5>
        <div className="mt-3">
          <p><strong>Ply Name:</strong> {selectedFormData.PlyName}</p>
          <p><strong>Type:</strong> {selectedFormData.TypeName}</p>
          <p><strong>Inside:</strong> {selectedFormData.InsidePaperNames}</p>
          <p><strong>Outside:</strong> {selectedFormData.OutsidePaperNames}</p>
        </div>
      </div>
    );
  }

  render() {
    const { loading, error } = this.state;

    if (loading) {
      return <div className="text-center p-5">Loading...</div>;
    }

    if (error) {
      return <div className="text-center text-danger p-5">{error}</div>;
    }

    return (
      <div className="page-content">
        <RCDisplayPage
          //page header parameters
          Isbreadcrumb={true}
          breadCrumbTitle={this.breadCrumbTitle}
          breadcrumbItem={this.breadCrumbItem}
          obj={this.obj}
          //column parameters
          isSearchBox={true}
          isSNo={true}
          isCheckBox={false}
          isViewDetails={true}
          //grid parameters
          gridData={this.state.gridData}
          gridHeader={this.renderGridHeader}
          gridBody={this.renderGridBody}
          btnAdd_onClick={this.btnAdd_onClick}
          btnEdit_onClick={this.btnEdit_onClick}
          //delete link parameters
          confirm_alert={this.state.confirm_alert}
          success_dlg={this.state.success_dlg}
          dynamic_title={this.state.dynamic_title}
          dynamic_description={this.state.dynamic_description}
          toggleDeleteConfirm={toggleDeleteConfirm}
        toggleDeleteSuccess={toggleDeleteSuccess}
        btnDelete_onClick={this.btnDelete_onClick}
          //modal parameters
          isOpenModal={this.state.modal}
          modalTitle={this.modalTitle}
          selectedFormData={this.state.selectedFormData}
          modalBody={this.renderModalBody}
          togglemodal={togglemodal}
          //user rights
          isAdd={this.state.isAdd}
          isEdit={this.state.isEdit}
          isDelete={this.state.isDelete}
          //additional features
          onRefresh={this.handleRefresh}
          showRefresh={true}
        />
      </div>
    );
  }
}

export default compose(container)(pageList_PlyAdjustment);
